import React, { useState } from "react";

const mechanicalInstruments = [
  "Vernier Caliper",
  "Surface Plate",
  "Outside Micrometer",
  "Dial Thickness Gauge",
  "Height Gauge",
  "Measuring Sieves",
  "Coating Thickness Meter",
  "Snap Gauge",
  "Vernier Depth Gauge",
  "Dial Snap Gauge",
  "Depth Micrometer",
  "Weighing Balance",
  "Pistol Caliper",
  "Ultrasonic Thickness Meter",
  "Shim Foils",
  "Pressure Gauges",
  "Feeler Gauge",
  "Vacuum Gauges",
  "Pressure Transmitters",
  "Vacuum Transmitter"
];

const electroTechnicalInstruments = [
  "Temperature Controller",
  "Multimeter",
  "Temperature Indicator",
  "Voltmeter",
  "Temperature Scanner",
  "Clamp Meter",
  "Temperature Recorder",
  "Timer",
  "Temperature Transmitter",
  "Stopwatch",
  "Differential Pressure (DP) Transmitter",
  "Universal Calibrator"
];

const thermalInstruments = [
  "Temperature Sensor",
  "Oven",
  "Temperature Gauge",
  "Thermohygrometer",
  "Digital Thermometer",
  "Temperature Transmitter",
  "Temperature Recorder",
  "Thermocouple",
  "Muffle Furnace",
  "Temperature Indicator with Sensor",
  "Refrigerator",
  "Hot Plate",
  "Temperature Calibrator",
  "Freezer",
  "IR Gun"
];

const temperatureMappingItems = [
  "All Types of Oven",
  "Hardening Furnace",
  "Baking Oven",
  "Area Mapping",
  "BOD Incubator",
  "Refrigerator",
  "Vacuum Oven",
  "Muffle Furnace",
  "Autoclave",
  "Tempering Furnace",
  "Dry Heat Sterilizer",
  "Deep Freeze",
  "Tunnel Dryer",
  "Tray Dryer",
  "All Types of Furnace"
];

const civilLabInstruments = [
  "Test Sieves",
  "Measuring Tape",
  "Beam Mould",
  "Measuring Scale",
  "Cube Mould",
  "Analytical Weight Box",
  "Slump Cone",
  "Standard Weights",
  "Cone Penetrometer (Soil)",
  "Weighing Balance",
  "Bitumen Penetrometer",
  "Flakiness Gauge",
  "Plunger Dial Gauge",
  "Elongation Gauge",
  "Vibrating Machine",
  "Oven",
  "Ductility Test Machine",
  "Water Bath",
  "Vicat Apparatus",
  "Humidity Chamber",
  "Digital Thermometer",
  "Glass Thermometer",
  "Temperature Controller",
  "Thermohygrometer",
  "Liquid Limit Apparatus",
  "Measuring Cylinder",
  "Specific Gravity Bottle",
  "pH Meter",
  "Stopwatch",
  "Hot Plate",
  "Bitumen Extractor",
  "Beaker",
  "Casagrande Apparatus",
  "Hydrometer",
  "Measuring Flask",
  "Vernier Caliper",
  "Volumetric Flask",
  "Micrometer",
  "Ring & Ball Apparatus",
  "Thermostat",
  "Dial Type Thermometers"
];

const repairItems = [
  "Vernier Caliper",
  "External Micrometer",
  "Digital Vernier Caliper",
  "Internal Micrometer",
  "Dial Vernier Caliper",
  "Dial Gauges",
  "Height Gauge",
  "Bevel Protractor",
  "Temperature Controllers",
  "Oven",
  "Muffle Furnace",
  "Weighing Balance",
  "Water Bath",
  "BOD Incubator"
];

const tradingItems = [
  "Temperature Controller",
  "All Types of Temperature Sensors (RTD, Thermocouple)",
  "Temperature Indicator",
  "Universal Calibrator",
  "Vernier Caliper",
  "Micrometer",
  "Data Logger",
  "Bevel Protractor",
  "Pressure Gauge",
  "Temperature Gauge",
  "Vacuum Gauge",
  "Thermometer",
  "Bore Gauge",
  "Hygrometer",
  "Lever Dial Gauge",
  "Plunger Dial Gauge",
  "Tachometer",
  "pH Meter",
  "Weighing Balance",
  "Opacity Meter"
];

// Component to render instrument grid
const InstrumentGrid = ({ title, items, color }) => {
  return (
    <div className="mb-16">
      <div className="text-center mb-10">
        <h3 className={`text-2xl md:text-3xl font-bold text-gray-800 inline-block px-8 py-3 border-b-4 border-${color}-600 rounded-t-lg bg-${color}-50`}>
          {title}
        </h3>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 xl:grid-cols-4 gap-6">
        {items.map((item, index) => (
          <div
            key={index}
            className="bg-white rounded-2xl shadow-md hover:shadow-2xl transform hover:-translate-y-2 transition-all duration-300 p-6 border border-gray-200 text-center text-gray-800 text-base font-medium flex items-center justify-center min-h-[100px] hover:border-blue-400"
          >
            {item}
          </div>
        ))}
      </div>
    </div>
  );
};

const Services = () => {
  const [activeTab, setActiveTab] = useState("calibration");

  const tabs = [
    { id: "calibration", label: "Calibration Services" },
    { id: "mapping", label: "Temperature Mapping & Validation" },
    { id: "repair", label: "Repair Services" },
    { id: "trading", label: "Trading" }
  ];

  return (
    <div>
      {/* Hero Section */}
      <div
        className="h-[16rem] md:h-[20rem] bg-cover relative bg-center flex items-center justify-center text-white"
        style={{
          backgroundImage: 'url("./img/product.jpeg")',
        }}
      >
        <div className="absolute inset-0 bg-gradient-to-b from-slate-800/70 to-slate-900/90"></div>
        <div className="relative z-10 text-center px-6">
          <h1 className="text-4xl md:text-6xl lg:text-7xl font-extrabold mb-4 tracking-wide">
            Our Services
          </h1>
          <p className="text-lg md:text-xl text-slate-100 max-w-3xl mx-auto">
            Comprehensive Calibration, Validation, Repair & Trading Solutions
          </p>
        </div>
      </div>

      {/* Tabs Section */}
      <section className="py-12 px-4 bg-gray-50">
        <div className="max-w-6xl mx-auto">
          <div className="flex flex-wrap gap-4 justify-center mb-12">
            {tabs.map((tab) => (
              <button
                key={tab.id}
                onClick={() => setActiveTab(tab.id)}
                className={`py-4 px-6 rounded-xl text-lg md:text-xl font-bold transition-all duration-300 shadow-lg ${
                  activeTab === tab.id
                    ? "bg-gradient-to-r from-blue-700 to-blue-600 text-white shadow-2xl transform scale-105"
                    : "bg-white text-gray-700 border-2 border-gray-200 hover:border-blue-400 hover:shadow-xl"
                }`}
              >
                {tab.label}
              </button>
            ))}
          </div>

          {/* Content */}
          <div className="min-h-[600px]">
            {activeTab === "calibration" && (
              <div className="animate-fade-in">
                <InstrumentGrid title="Mechanical Instruments" items={mechanicalInstruments} color="blue" />
                <InstrumentGrid title="Electro-Technical Instruments" items={electroTechnicalInstruments} color="blue" />
                <InstrumentGrid title="Thermal Instruments" items={thermalInstruments} color="blue" />
                <InstrumentGrid title="Civil Lab Instruments" items={civilLabInstruments} color="blue" />
              </div>
            )}
            {activeTab === "mapping" && (
              <div className="animate-fade-in">
                <div className="text-center mb-6">
                  <p className="text-lg text-gray-700 mb-8">As per CQI-9 (4th Edition) & AMS 2750E Standards</p>
                </div>
                <InstrumentGrid title="Temperature Mapping & Validation" items={temperatureMappingItems} color="green" />
              </div>
            )}
            {activeTab === "repair" && (
              <div className="animate-fade-in">
                <InstrumentGrid title="Instruments & Equipment Repairing" items={repairItems} color="orange" />
              </div>
            )}
            {activeTab === "trading" && (
              <div className="animate-fade-in">
                <InstrumentGrid title="Trading - Supply of New Instruments & Equipment" items={tradingItems} color="gray" />
              </div>
            )}
          </div>
        </div>
      </section>
    </div>
  );
};

export default Services;
